/* eslint-disable @typescript-eslint/ban-ts-comment */
import { Icon } from '@ps/isp-web-component-library';
import { InPlay } from '@ps/isp-web-component-library/icons/InPlay';
import classNames from 'clsx';
import React from 'react';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';

import { TXTWCL_In_Play } from './AnimatedInPlayIcon.messages.json';
import styles from './AnimatedInPlayIcon.scss';

interface Props {
  className?: string;
}

const AnimatedInPlayIcon: React.FC<Props> = ({ className }) => {
  const { formatMessage } = useRegulatoryIntl();
  return (
    <Icon
      icon={InPlay}
      size="sm"
      className={classNames(className, styles.inPlayIcon)}
      label={formatMessage(TXTWCL_In_Play)}
    />
  );
};

export default AnimatedInPlayIcon;
